import React from 'react';
import i18n from 'i18next';
import Link from 'next/link';

const MenuItem = ({ menu, onClick, onClose, isActive }) => {
    const name =
        menu.names?.find((item) => item.langCode === i18n.language)?.name ||
        menu.names?.[0]?.name ||
        '';
    const hasChildren = menu.children?.length > 0;

    const baseStyle = {
        listStyle: 'none',
        padding: '0 10px',
        fontSize: 14,
        fontWeight: 400,
        letterSpacing: '0.01em',
        textTransform: 'uppercase',
        color: isActive ? 'hsl(var(--primary))' : '#111827',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        userSelect: 'none',
        transition: 'color .15s',
    };

    if (!hasChildren) {
        return (
            <li style={baseStyle}>
                <Link
                    href={menu.url ? '/' + menu.url : '/content/' + menu.id}
                    passHref
                    onClick={onClose}
                    style={{ color: 'inherit', textDecoration: 'none' }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = 'hsl(var(--primary))')}
                    onMouseLeave={(e) => {
                        if (!isActive) e.currentTarget.style.color = '#111827';
                    }}
                >
                    {name}
                </Link>
            </li>
        );
    }

    return (
        <li
            style={baseStyle}
            onClick={onClick}
            onMouseEnter={(e) => (e.currentTarget.style.color = 'hsl(var(--primary))')}
            onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.color = '#111827';
            }}
        >
            {name}
        </li>
    );
};

export default MenuItem;
